(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fineri-account-dashboard"] && !Shopify.designMode) return;
  try {
    
(function() {
  const dashboard = document.querySelector('[data-section-id="{{ section.id }}"]');
  if (!dashboard) return;
  
  const tabButtons = dashboard.querySelectorAll('[role="tab"]');
  const tabPanels = dashboard.querySelectorAll('[role="tabpanel"]');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.getAttribute('data-tab');
      
      // Update buttons
      tabButtons.forEach(btn => {
        const isActive = btn.getAttribute('data-tab') === tabId;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      
      // Update panels
      tabPanels.forEach(panel => {
        const isActive = panel.id === 'panel-' + tabId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fineri-collection-hero"]) return;
  try {
    
(function () {
  function initHeroCarousel(root) {
    if (!root || root.getAttribute('data-fineri-carousel-init') === '1') return;
    root.setAttribute('data-fineri-carousel-init', '1');
    var slides = root.querySelectorAll('.fineri-hero__slide');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-fineri-hero-dot]');
    var prev = root.querySelector('[data-fineri-hero-prev]');
    var next = root.querySelector('[data-fineri-hero-next]');
    var slidesRegion = root.querySelector('.fineri-hero__slides');
    var intervalMs = parseInt(String(root.getAttribute('data-interval') || ''), 10) || 6000;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var reduced =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0;
    var timer = null;

    function setActive(nextIndex) {
      var n = (nextIndex + slides.length) % slides.length;
      i = n;
      slides.forEach(function (s, j) {
        var active = j === n;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        s.querySelectorAll('.fineri-hero__slide-bg video').forEach(function (v) {
          if (active && !reduced) {
            playHeroVideo(v);
          } else {
            v.pause();
          }
        });
      });
      dots.forEach(function (d, j) {
        var on = j === n;
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        d.classList.toggle('is-active', on);
      });
    }
    function goNext() {
      setActive(i + 1);
    }
    function goPrev() {
      setActive(i - 1);
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function start() {
      stop();
      if (!autoplay || reduced || document.hidden || slides.length < 2) return;
      timer = setInterval(goNext, intervalMs);
    }
    if (prev)
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        goPrev();
        start();
      });
    if (next)
      next.addEventListener('click', function (e) {
        e.preventDefault();
        goNext();
        start();
      });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var idx = parseInt(d.getAttribute('data-fineri-hero-dot'), 10);
        if (!isNaN(idx)) {
          setActive(idx);
          start();
        }
      });
    });
    if (slidesRegion) {
      slidesRegion.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goPrev();
          start();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          goNext();
          start();
        }
      });
    }
    var hero = root.closest('.fineri-hero');
    if (hero) {
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
    start();
  }
  function playHeroVideo(v) {
    if (!v || v.tagName !== 'VIDEO') return;
    v.muted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    var playPromise = v.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {
        v.addEventListener(
          'loadeddata',
          function once() {
            v.removeEventListener('loadeddata', once);
            v.play().catch(function () {});
          },
          { once: true }
        );
      });
    }
  }
  function initHeroVideos(scope) {
    var root = scope || document;
    var reduced =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('.fineri-hero__section-video video, .fineri-hero__bg video, .fineri-hero__slide-bg video').forEach(function (v) {
      if (reduced) {
        v.pause();
        v.removeAttribute('autoplay');
        return;
      }
      var slide = v.closest('.fineri-hero__slide');
      if (slide && !slide.classList.contains('is-active')) {
        v.pause();
        return;
      }
      playHeroVideo(v);
    });
  }
  function boot() {
    document.querySelectorAll('[data-fineri-hero-carousel]').forEach(initHeroCarousel);
    initHeroVideos(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target;
    if (!t || !t.querySelectorAll) return;
    t.querySelectorAll('[data-fineri-hero-carousel]').forEach(initHeroCarousel);
    initHeroVideos(t);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fineri-collection-plp"]) return;
  try {
    
  (function () {
    function priceMajorParam(value) {
      var n = Math.round(value * 100) / 100;
      return Math.abs(n - Math.round(n)) < 1e-9 ? String(Math.round(n)) : String(n);
    }

    function syncPriceFacets(form) {
      var root = form || document;
      root.querySelectorAll('[data-fineri-price-range]').forEach(function (row) {
        var hMin = row.querySelector('[data-fineri-price-hidden="min"]');
        var hMax = row.querySelector('[data-fineri-price-hidden="max"]');
        var mMin = row.querySelector('[data-fineri-price-major="min"]');
        var mMax = row.querySelector('[data-fineri-price-major="max"]');
        if (hMin && mMin) {
          var v = parseFloat(String(mMin.value).replace(',', '.'), 10);
          if (!isNaN(v) && v >= 0) {
            hMin.value = priceMajorParam(v);
            hMin.removeAttribute('disabled');
          } else {
            hMin.value = '';
            hMin.setAttribute('disabled', 'disabled');
          }
        }
        if (hMax && mMax) {
          var v2 = parseFloat(String(mMax.value).replace(',', '.'), 10);
          if (!isNaN(v2) && v2 >= 0) {
            hMax.value = priceMajorParam(v2);
            hMax.removeAttribute('disabled');
          } else {
            hMax.value = '';
            hMax.setAttribute('disabled', 'disabled');
          }
        }
      });
    }

    // Capture phase so currency-unit sync runs before fineri-filters.js reads FormData.
    document.addEventListener(
      'submit',
      function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('#FineriFacetsForm, .fineri-facets__form')) {
          syncPriceFacets(t);
        }
      },
      true
    );

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.form) return;
      if (target.form.id !== 'FineriFacetsForm' && !target.form.classList.contains('fineri-facets__form')) {
        return;
      }

      if (target.matches('input[type="checkbox"], input[type="radio"]')) {
        target.form.requestSubmit();
      }
    });

    document.addEventListener('keydown', function (e) {
      var target = e.target;
      if (!target || !target.form) return;
      if (target.form.id !== 'FineriFacetsForm' && !target.form.classList.contains('fineri-facets__form')) {
        return;
      }

      if (
        e.key === 'Enter' &&
        target.matches('[data-fineri-price-major="min"], [data-fineri-price-major="max"]')
      ) {
        e.preventDefault();
        target.form.requestSubmit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fineri-hero"]) return;
  try {
    
(function () {
  function initHeroCarousel(root) {
    if (!root || root.getAttribute('data-fineri-carousel-init') === '1') return;
    root.setAttribute('data-fineri-carousel-init', '1');
    var slides = root.querySelectorAll('.fineri-hero__slide');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-fineri-hero-dot]');
    var prev = root.querySelector('[data-fineri-hero-prev]');
    var next = root.querySelector('[data-fineri-hero-next]');
    var slidesRegion = root.querySelector('.fineri-hero__slides');
    var intervalMs = parseInt(String(root.getAttribute('data-interval') || ''), 10) || 6000;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var reduced =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0;
    var timer = null;

    function setActive(nextIndex) {
      var n = (nextIndex + slides.length) % slides.length;
      i = n;
      slides.forEach(function (s, j) {
        var active = j === n;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        s.querySelectorAll('.fineri-hero__slide-bg video').forEach(function (v) {
          if (active && !reduced) {
            playHeroVideo(v);
          } else {
            v.pause();
          }
        });
      });
      dots.forEach(function (d, j) {
        var on = j === n;
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        d.classList.toggle('is-active', on);
      });
    }
    function goNext() {
      setActive(i + 1);
    }
    function goPrev() {
      setActive(i - 1);
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function start() {
      stop();
      if (!autoplay || reduced || document.hidden || slides.length < 2) return;
      timer = setInterval(goNext, intervalMs);
    }
    if (prev)
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        goPrev();
        start();
      });
    if (next)
      next.addEventListener('click', function (e) {
        e.preventDefault();
        goNext();
        start();
      });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var idx = parseInt(d.getAttribute('data-fineri-hero-dot'), 10);
        if (!isNaN(idx)) {
          setActive(idx);
          start();
        }
      });
    });
    if (slidesRegion) {
      slidesRegion.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goPrev();
          start();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          goNext();
          start();
        }
      });
    }
    var hero = root.closest('.fineri-hero');
    if (hero) {
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
    start();
  }
  function playHeroVideo(v) {
    if (!v || v.tagName !== 'VIDEO') return;
    v.muted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    var playPromise = v.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {
        v.addEventListener(
          'loadeddata',
          function once() {
            v.removeEventListener('loadeddata', once);
            v.play().catch(function () {});
          },
          { once: true }
        );
      });
    }
  }
  function initHeroVideos(scope) {
    var root = scope || document;
    var reduced =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('.fineri-hero__section-video video, .fineri-hero__bg video, .fineri-hero__slide-bg video').forEach(function (v) {
      if (reduced) {
        v.pause();
        v.removeAttribute('autoplay');
        return;
      }
      var slide = v.closest('.fineri-hero__slide');
      if (slide && !slide.classList.contains('is-active')) {
        v.pause();
        return;
      }
      playHeroVideo(v);
    });
  }
  function boot() {
    document.querySelectorAll('[data-fineri-hero-carousel]').forEach(initHeroCarousel);
    initHeroVideos(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target;
    if (!t || !t.querySelectorAll) return;
    t.querySelectorAll('[data-fineri-hero-carousel]').forEach(initHeroCarousel);
    initHeroVideos(t);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fineri-landing-hero"]) return;
  try {
    
(function () {
  function initHeroCarousel(root) {
    if (!root || root.getAttribute('data-fineri-carousel-init') === '1') return;
    root.setAttribute('data-fineri-carousel-init', '1');
    var slides = root.querySelectorAll('.fineri-hero__slide');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-fineri-hero-dot]');
    var prev = root.querySelector('[data-fineri-hero-prev]');
    var next = root.querySelector('[data-fineri-hero-next]');
    var slidesRegion = root.querySelector('.fineri-hero__slides');
    var intervalMs = parseInt(String(root.getAttribute('data-interval') || ''), 10) || 6000;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var reduced =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0;
    var timer = null;

    function setActive(nextIndex) {
      var n = (nextIndex + slides.length) % slides.length;
      i = n;
      slides.forEach(function (s, j) {
        var active = j === n;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        s.querySelectorAll('.fineri-hero__slide-bg video').forEach(function (v) {
          if (active && !reduced) {
            playHeroVideo(v);
          } else {
            v.pause();
          }
        });
      });
      dots.forEach(function (d, j) {
        var on = j === n;
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        d.classList.toggle('is-active', on);
      });
    }
    function goNext() {
      setActive(i + 1);
    }
    function goPrev() {
      setActive(i - 1);
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function start() {
      stop();
      if (!autoplay || reduced || document.hidden || slides.length < 2) return;
      timer = setInterval(goNext, intervalMs);
    }
    if (prev)
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        goPrev();
        start();
      });
    if (next)
      next.addEventListener('click', function (e) {
        e.preventDefault();
        goNext();
        start();
      });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var idx = parseInt(d.getAttribute('data-fineri-hero-dot'), 10);
        if (!isNaN(idx)) {
          setActive(idx);
          start();
        }
      });
    });
    if (slidesRegion) {
      slidesRegion.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goPrev();
          start();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          goNext();
          start();
        }
      });
    }
    var hero = root.closest('.fineri-hero');
    if (hero) {
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
    start();
  }
  function playHeroVideo(v) {
    if (!v || v.tagName !== 'VIDEO') return;
    v.muted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    var playPromise = v.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {
        v.addEventListener(
          'loadeddata',
          function once() {
            v.removeEventListener('loadeddata', once);
            v.play().catch(function () {});
          },
          { once: true }
        );
      });
    }
  }
  function initHeroVideos(scope) {
    var root = scope || document;
    var reduced =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('.fineri-hero__section-video video, .fineri-hero__bg video, .fineri-hero__slide-bg video').forEach(function (v) {
      if (reduced) {
        v.pause();
        v.removeAttribute('autoplay');
        return;
      }
      var slide = v.closest('.fineri-hero__slide');
      if (slide && !slide.classList.contains('is-active')) {
        v.pause();
        return;
      }
      playHeroVideo(v);
    });
  }
  function boot() {
    document.querySelectorAll('[data-fineri-hero-carousel]').forEach(initHeroCarousel);
    initHeroVideos(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target;
    if (!t || !t.querySelectorAll) return;
    t.querySelectorAll('[data-fineri-hero-carousel]').forEach(initHeroCarousel);
    initHeroVideos(t);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fineri-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function cardStep(track) {
      var card = track.querySelector('.fineri-testimonials__card');
      if (!card) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function maxIndex(track) {
      var cards = track.querySelectorAll('.fineri-testimonials__card');
      if (!cards.length) return 0;
      var step = cardStep(track) || 1;
      var visible = Math.max(1, Math.floor((track.clientWidth + 4) / step));
      return Math.max(0, cards.length - visible);
    }

    function nearestIndex(track) {
      var step = cardStep(track);
      if (!step) return 0;
      return Math.round(track.scrollLeft / step);
    }

    function syncUi(root) {
      var track = root.querySelector('[data-fineri-reviews-track]');
      if (!track) return;
      var idx = nearestIndex(track);
      var max = maxIndex(track);
      var clamped = Math.max(0, Math.min(idx, max));
      var prev = root.querySelector('[data-fineri-reviews-prev]');
      var next = root.querySelector('[data-fineri-reviews-next]');
      if (prev) prev.disabled = clamped <= 0;
      if (next) next.disabled = clamped >= max;

      root.querySelectorAll('[data-fineri-reviews-dot]').forEach(function (dot, i) {
        var on = i === clamped;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function scrollToIndex(track, index) {
      var step = cardStep(track);
      var max = maxIndex(track);
      var next = Math.max(0, Math.min(index, max));
      track.scrollTo({ left: next * step, behavior: 'smooth' });
    }

    function initCarousel(root) {
      if (!root || root.getAttribute('data-fineri-reviews-init') === '1') return;
      var track = root.querySelector('[data-fineri-reviews-track]');
      if (!track) return;
      root.setAttribute('data-fineri-reviews-init', '1');

      var timer = null;
      var autoplay = root.getAttribute('data-autoplay') !== 'false';
      var delay = parseInt(root.getAttribute('data-autoplay-ms') || '4000', 10);
      if (isNaN(delay) || delay < 2000) delay = 4000;

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplay) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(function () {
          var idx = nearestIndex(track);
          var max = maxIndex(track);
          var next = idx >= max ? 0 : idx + 1;
          scrollToIndex(track, next);
        }, delay);
      }

      function bumpAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      var prev = root.querySelector('[data-fineri-reviews-prev]');
      var next = root.querySelector('[data-fineri-reviews-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          scrollToIndex(track, nearestIndex(track) - 1);
          bumpAutoplay();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollToIndex(track, nearestIndex(track) + 1);
          bumpAutoplay();
        });
      }

      root.querySelectorAll('[data-fineri-reviews-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-index') || '0', 10);
          scrollToIndex(track, i);
          bumpAutoplay();
        });
      });

      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            syncUi(root);
            ticking = false;
          });
        },
        { passive: true }
      );

      track.addEventListener(
        'pointerdown',
        function () {
          stopAutoplay();
        },
        { passive: true }
      );
      track.addEventListener(
        'pointerup',
        function () {
          bumpAutoplay();
        },
        { passive: true }
      );

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', function (ev) {
        if (!root.contains(ev.relatedTarget)) startAutoplay();
      });

      window.addEventListener('resize', function () {
        syncUi(root);
      });

      syncUi(root);
      startAutoplay();
    }

    function boot() {
      document.querySelectorAll('[data-fineri-reviews-carousel]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (ev) {
      var t = ev.target;
      if (!t || !t.querySelectorAll) return;
      t.querySelectorAll('[data-fineri-reviews-carousel]').forEach(function (el) {
        el.removeAttribute('data-fineri-reviews-init');
        initCarousel(el);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
